module.exports = __webpack_public_path__ + "img/65735.40345599.png";